import { lazy } from "react";

const Index = lazy(() => import("./List"));
const Create = lazy(() => import("./Create"));
const Detail = lazy(() => import("./Detail"));

export { Index, Create, Detail };
